import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axiosInstance';
import { BASE_URL } from '../../utils/constants';
import { getErrorMessage } from '../../utils/helper';

const HONORARIUM_ENDPOINT = 'honorarium';

export const fetchHonorariums = createAsyncThunk(
  'honorarium/fetch',
  async ({ month, year, page = 1, limit = 10 }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `${BASE_URL}${HONORARIUM_ENDPOINT}?month=${month}&year=${year}&page=${page}&limit=${limit}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, 'Failed to fetch honorariums'));
    }
  }
);

export const fetchHonorariumDetails = createAsyncThunk(
  'honorarium/fetchDetails',
  async (honorariumId, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `${BASE_URL}${HONORARIUM_ENDPOINT}/${honorariumId}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, 'Failed to fetch honorarium details'));
    }
  }
);

export const updateHonorariumStatus = createAsyncThunk(
  'honorarium/updateStatus',
  async ({ honorariumId, paymentStatus, paymentDate, paymentMethod, remarks }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.patch(
        `${BASE_URL}${HONORARIUM_ENDPOINT}/${honorariumId}/status`,
        {
          paymentStatus,
          remarks,
          ...(paymentStatus === 'Paid' && {
            paymentDate,
            paymentMethod
          })
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, 'Failed to update honorarium status'));
    }
  }
);

export const fetchTeacherHonorarium = createAsyncThunk(
  'honorarium/fetchTeacherHonorarium',
  async ({ page = 1, limit = 10 }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`${BASE_URL}honorarium/my-honorarium`, {
        params: { page, limit }
      });
      return response.data.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, 'Failed to fetch honorarium details'));
    }
  }
); 

// Manual honorarium creation — Accountant / MD / Super Admin only. The backend
// gates the role; the UI hides the button for everyone else.
export const createHonorarium = createAsyncThunk(
  'honorarium/create',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        `${BASE_URL}${HONORARIUM_ENDPOINT}`,
        payload
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, 'Failed to create honorarium'));
    }
  }
);

export const updateHonorariumApprovalStatus = createAsyncThunk(
  'honorarium/updateApprovalStatus',
  async ({ honorariumId, adminApproved, remarks }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.patch(
        `${BASE_URL}${HONORARIUM_ENDPOINT}/${honorariumId}/admin-approval`,
        {
          adminApproved,
          remarks,
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, 'Failed to update honorarium status'));
    }
  }
);

